import { AxiosResponse } from "axios";
import { axiosInstance } from "src/services/axiosSetup";
import * as API_URL from "src/services/consts/Investments"

export function getInvestmentCalculationsRequestApi(data: { investment_amount: string  }): Promise<any> {
    return axiosInstance.post(`${API_URL.URL_GET_INVESTMENT_CALCULATION}`, { ...data }).then((d: AxiosResponse) => d.data);
}
